"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../../Theme"));
var _Title = _interopRequireDefault(require("../../Title"));
var _StepperButton = _interopRequireDefault(require("../../StepperButton"));
var _constant = require("../../StepperButton/constant");
var _stepper = _interopRequireDefault(require("./stepper.proptypes"));
var _constant2 = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StepperWrapper = _styledComponents.default.div.withConfig({
  displayName: "Stepper__StepperWrapper",
  componentId: "sc-1ky8p8k-0"
})(["display:flex;align-items:center;justify-content:space-between;"]);
var CustomTitle = (0, _styledComponents.default)(_Title.default).withConfig({
  displayName: "Stepper__CustomTitle",
  componentId: "sc-1ky8p8k-1"
})(["margin:0 ", ";width:30px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
});
var Stepper = function Stepper(props) {
  var number = props.number,
    onIncrement = props.onIncrement,
    onDecrement = props.onDecrement,
    disableDecrement = props.disableDecrement,
    disableIncrement = props.disableIncrement,
    min = props.min,
    max = props.max,
    theme = props.theme,
    labelColor = props.labelColor,
    stepperButtonConfig = props.stepperButtonConfig,
    accessible = props.accessible,
    customProperties = props.customProperties,
    className = props.className,
    paxType = props.paxType;
  var _ref2 = stepperButtonConfig || {},
    stepperAdd = _ref2.stepperAdd,
    stepperMinus = _ref2.stepperMinus;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var belowMin = min != null && number <= min;
  var aboveMax = max != null && number >= max;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StepperWrapper, (0, _extends2.default)({
      id: "stepper",
      tabIndex: tabIndex,
      className: className
    }, customProperties), /*#__PURE__*/_react.default.createElement(_StepperButton.default, (0, _extends2.default)({
      paxType: paxType,
      isIncrement: false,
      stepperType: _constant.STEPPER_BUTTON_TYPE.MINUS,
      onStepperClicked: onDecrement,
      disabled: belowMin || disableDecrement,
      theme: theme,
      "data-test": "decrement-button",
      "aria-label": "decrement-button"
    }, stepperMinus)), /*#__PURE__*/_react.default.createElement(CustomTitle, {
      accessible: true,
      theme: themeContext,
      type: _constant2.DEFAULT_STYLES.LABEL_TYPE,
      textAlign: "center",
      color: labelColor,
      "data-test": "counter-label",
      "aria-label": "counter-label"
    }, number), /*#__PURE__*/_react.default.createElement(_StepperButton.default, (0, _extends2.default)({
      id: "home_adult_add",
      stepperType: _constant.STEPPER_BUTTON_TYPE.ADD,
      onStepperClicked: onIncrement,
      disabled: aboveMax || disableIncrement,
      theme: themeContext,
      "data-test": "increment-button",
      "aria-label": "increment-button",
      customProperties: customProperties,
      paxType: paxType,
      isIncrement: true
    }, stepperAdd)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Stepper.propTypes = _stepper.default.PropTypes;
Stepper.defaultProps = _stepper.default.DefaultProps;
var _default = Stepper;
exports.default = _default;